export function buildMetaHead(inputs) {
  const head = {};
  const meta = [];
  const link = [];
  const script = [];

  if (inputs.title || inputs.mandatoryTitle) {
    let formattedTitle = inputs.mandatoryTitle
      ? inputs.mandatoryTitle
      : inputs.title && inputs.title !== 'The Hub'
      ? 'The Hub | ' + inputs.title
      : 'The Hub';

    head.title = formattedTitle;
    meta.push({ hid: 'og:title', property: 'og:title', content: formattedTitle });
    meta.push({ hid: 'twitter:title', name: 'twitter:title', content: formattedTitle });
  }

  if (inputs.path) {
    inputs.url = inputs.isPreview ? `https://${inputs.path}` : process.env.BASE_URL + inputs.path;
  }

  if (inputs.url) {
    meta.push({ hid: 'twitter:url', name: 'twitter:url', content: inputs.url });
    meta.push({ hid: 'og:url', property: 'og:url', content: inputs.url });
    link.push({ hid: 'link:canonical', rel: 'canonical', href: inputs.url });
  }

  if (inputs.description) {
    inputs.description =
      inputs.description.length > 200
        ? inputs.description.substr(0, 200) + ' ...'
        : inputs.description;

    meta.push({ hid: 'description', name: 'description', content: inputs.description });
    meta.push({ hid: 'og:description', property: 'og:description', content: inputs.description });
    meta.push({
      hid: 'twitter:description',
      name: 'twitter:description',
      content: inputs.description
    });
  }

  if (inputs.imageUrl) {
    meta.push({ hid: 'og:image', property: 'og:image', content: inputs.imageUrl });
    meta.push({ hid: 'twitter:image', property: 'twitter:image', content: inputs.imageUrl });
  }

  if (inputs.googleJob) {
    script.push({
      hid: 'ldjson-schema',
      type: 'application/ld+json',
      innerHTML: inputs.googleJob
    });
  }

  if (inputs.noindex) {
    meta.push({ hid: 'robots', name: 'robots', content: 'noindex, nofollow' });
  }

  if (inputs.favicon) {
    const normalize = (url) =>
      url.startsWith('//') ? 'https:' + url : url.startsWith('http') ? url : 'https://' + url;

    const href = normalize(inputs.favicon);

    const ext = href
      .split('.')
      .pop()
      .toLowerCase();
    const typeMap = {
      ico: 'image/x-icon',
      png: 'image/png',
      svg: 'image/svg+xml',
      webp: 'image/webp',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg'
    };
    const type = typeMap[ext] || 'image/png';

    link.push({
      hid: 'favicon',
      rel: 'icon',
      type,
      href
    });

    link.push({
      hid: 'favicon32',
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href
    });

    link.push({
      hid: 'favicon16',
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href
    });

    link.push({
      hid: 'apple-touch-icon',
      rel: 'apple-touch-icon',
      href
    });

    link.push({
      hid: 'shortcut-icon',
      rel: 'shortcut icon',
      href
    });
  }

  head.meta = meta;
  head.link = link;
  head.script = script;

  return head;
}
